export const inViewOptions = {
    // threshold: 0.3,
    rootMargin: '-100px 0px',
    triggerOnce: true,
}